// Keep in sync with app/lib/enums/resegmented_product_sort_field.py
export const ResegmentedProductSortField = Object.freeze({
  PRODUCT_NAME: 'product_name',
  SKU: 'sku',
  GLOBAL_PRODUCT_ID: 'global_product_id',
  BRAND_NAME: 'brand_name',
  ENTITY_NAME: 'entity_name',
  PRODUCT_TYPE: 'product_type',
  CLUSTER_NAME: 'openai_cluster_name',
  CLASS_NAME: 'openai_class_name',
});
